"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var base_service_1 = require("../base-service");
var alertminer_api_configuration_1 = require("../alertminer-api-configuration");
var operators_1 = require("rxjs/operators");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("../alertminer-api-configuration"));
var i2 = __importStar(require("@angular/common/http"));
var DealerUpgradeProposalSettingClientService = /** @class */ (function (_super) {
    __extends(DealerUpgradeProposalSettingClientService, _super);
    function DealerUpgradeProposalSettingClientService(config, http) {
        return _super.call(this, config, http) || this;
    }
    /**
     * @param dealerId undefined
     */
    DealerUpgradeProposalSettingClientService.prototype.GetDealerUpgradeProposalSettingByDealeridGETResponse = function (dealerId) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/DealerUpgradeProposalSetting/GetDealerUpgradeProposalSetting/" + dealerId), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param dealerId undefined
     */
    DealerUpgradeProposalSettingClientService.prototype.GetDealerUpgradeProposalSettingByDealeridGET = function (dealerId) {
        return this.GetDealerUpgradeProposalSettingByDealeridGETResponse(dealerId).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param request undefined
     */
    DealerUpgradeProposalSettingClientService.prototype.SaveDealerUpgradeProposalSettingPOSTResponse = function (request) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = request;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/DealerUpgradeProposalSetting/SaveDealerUpgradeProposalSetting", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param request undefined
     */
    DealerUpgradeProposalSettingClientService.prototype.SaveDealerUpgradeProposalSettingPOST = function (request) {
        return this.SaveDealerUpgradeProposalSettingPOSTResponse(request).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    DealerUpgradeProposalSettingClientService.GetDealerUpgradeProposalSettingByDealeridGETPath = '/api/DealerUpgradeProposalSetting/GetDealerUpgradeProposalSetting/{dealerId}';
    DealerUpgradeProposalSettingClientService.SaveDealerUpgradeProposalSettingPOSTPath = '/api/DealerUpgradeProposalSetting/SaveDealerUpgradeProposalSetting';
    DealerUpgradeProposalSettingClientService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DealerUpgradeProposalSettingClientService_Factory() { return new DealerUpgradeProposalSettingClientService(i0.ɵɵinject(i1.AlertminerApiConfiguration), i0.ɵɵinject(i2.HttpClient)); }, token: DealerUpgradeProposalSettingClientService, providedIn: "root" });
    return DealerUpgradeProposalSettingClientService;
}(base_service_1.BaseService));
exports.DealerUpgradeProposalSettingClientService = DealerUpgradeProposalSettingClientService;
